const Component = ({
    startLabel,
    endLabel
}: {
    startLabel: string;
    endLabel: string;
}) => (
    <>
        <div className="grTimelineOuter js-timeline-outer">
            <div className="grTimeline js-timeline-wrapper">
                <div
                    className="timeline-elastic js-timeline-elastic"
                    style={{ width: "100%", position: "relative" }}
                >
                    <div className="timeline-wrapper js-timeline-container">
                        {/* Add child timeline representation here */}
                    </div>
                </div>
            </div>
            <div className="grTimeGrid js-timegrid"></div>
        </div>

        <div className="grTimescale">
            <a
                href="#/date-select/time"
                className="grTimescale__label grTimescale__label--start js-label-start"
            >
                {startLabel}
            </a>
            <div className="grTimescale__container js-timescale-wrapper">
                <div className="grTimescale__clip js-timeline-clip"></div>
                <div className="grTimescale__slider">
                    <div className="js-timescale"></div>
                </div>
                <div
                    className="grTimescale__lollipop js-timeline-lollipop"
                    data-type="timescale"
                ></div>
            </div>
            <a
                href="#/date-select/time"
                className="grTimescale__label grTimescale__label--end js-label-end"
            >
                {endLabel}
            </a>
            <i className="js-zoom-out gb-icon-minus grTimescale__zoom-out grTimescale__icon"></i>
            <i className="js-zoom-in gb-icon-plus grTimescale__zoom-in grTimescale__icon"></i>
            <i className="js-zoom-to-selection gb-icon-zoomtoselection grTimescale__icon"></i>
        </div>
    </>
);
export default Component;
